<app-text-input
  class="full-width"
  appConfigSettingsInput
  placeholder="Beneficiary.RelationToInsured"
  [control]="customBeneficiaryFormGroup.get('relationToInsured')"
  [form]="customBeneficiaryFormGroup"
  showPlaceholder="false"
></app-text-input>

<div class="beneficiary-name" appConfigSettingsInput>
  <div>
    <app-initials-component
      placeholder="Insured.Initials"
      [control]="customBeneficiaryFormGroup.get('initials')"
      [form]="customBeneficiaryFormGroup"
    ></app-initials-component>
  </div>
  <div>
    <app-text-input
      class="full-width"
      placeholder="Insured.MiddleName"
      [control]="customBeneficiaryFormGroup.get('middleName')"
      [form]="customBeneficiaryFormGroup"
      showPlaceholder="false"
    ></app-text-input>
  </div>
</div>
<div>
  <app-text-input
    class="full-width"
    appConfigSettingsInput
    placeholder="Insured.Surname"
    [control]="customBeneficiaryFormGroup.get('surname')"
    [form]="customBeneficiaryFormGroup"
    showPlaceholder="false"
    capitalize="true"
  ></app-text-input>
</div>
<div>
  <app-toggle-input
    appConfigSettingsInput
    class="full-width"
    placeholder="Insured.Gender"
    [form]="customBeneficiaryFormGroup"
    [optionsList]="genderList"
    [control]="customBeneficiaryFormGroup.get('gender')"
    required
  ></app-toggle-input>
</div>
<div>
  <app-date-input
    appConfigSettingsInput
    class="full-width"
    placeholder="Insured.DateOfBirth"
    [control]="customBeneficiaryFormGroup.get('dateOfBirth')"
    [form]="customBeneficiaryFormGroup"
    datePlaceholder="CalculationInsurer.DateOfBirthPlaceholder"
    [dateMask]="dateMaskFormat"
  ></app-date-input>
</div>

